import React from "react";

import { CloseGreyIcon, ClockIcon, LocationGreyIcon, TelephoneIcon, MailGreyIcon, WifiIcon, FacebookIcon, InstagramIcon, LinkedinIcon, YoutubeIcon, TiktokIcon, XTwitterIcon, InternetIcon, NewTabIcon } from "../../../assets/icons";
import { Navigate } from "react-router-dom";
import { SocialLinkType } from "../../../models/base/SocialLinkType";
import { LocalInitClientSocialLinkDTO } from "../../../models/local/local.response";
import { motion } from "framer-motion";
import StreetMapView from "./StreetMapView";

interface LocalInfoViewProps {
    name: string;
    description: string;
    logoImageUrl: string;
    backgroundImageUrl: string;
    email: string;
    address: string;
    longitude: string;
    latitude: string;
    phoneNumber: string;
    website: string;
    workingHours: string;
    wiFiName: string;
    wiFiPassword: string;
    socialLinks: LocalInitClientSocialLinkDTO[];
    onClose: () => void;
}

const LocalInfoView: React.FC<LocalInfoViewProps> = ({ onClose, name, description, logoImageUrl, backgroundImageUrl, email, address, longitude, latitude, phoneNumber, website, workingHours, wiFiName, wiFiPassword, socialLinks }) => {

    const [isStreetMapViewOpen, setIsStreetMapViewOpen] = React.useState(false);

    const renderSocialIcon = (type: SocialLinkType) => {
        switch (type) {
            case SocialLinkType.Facebook:
                return FacebookIcon;
            case SocialLinkType.Instagram:
                return InstagramIcon;
            case SocialLinkType.LinkedIn:
                return LinkedinIcon;
            case SocialLinkType.YouTube:
                return YoutubeIcon;
            case SocialLinkType.TikTok:
                return TiktokIcon;
            case SocialLinkType.X:
                return XTwitterIcon;
            default:
                return undefined;
        }
    };

    return (
        <>
            {isStreetMapViewOpen && (
                <StreetMapView
                    longitude={longitude}
                    latitude={latitude}
                    onClose={() => setIsStreetMapViewOpen(false)}
                />
            )}

            <section className="modal-section local-info" onClick={onClose}>
                <motion.section
                    initial={{ opacity: 0, scale: 0.96, y: 12 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.96, y: 12 }}
                    transition={{ duration: 0.2 }}
                >
                    <div className="w-layout-blockcontainer container w-container">
                        <div className="modal-wrapper">
                            <div className="modal-div" onClick={(e) => e.stopPropagation()}>
                                <div className="modal-header-div">
                                    <div>
                                        <div className="modal-header">
                                            Informacije<br />
                                        </div>
                                    </div>
                                    <div className="modal-button-div" onClick={onClose}>
                                        <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" />
                                    </div>
                                </div>
                                <div className="modal-main-div">
                                    <div className="client-modal-lical-info-header">
                                        <div className="client-modal-lical-info-header-image-div">
                                            <img src={logoImageUrl + "@ul.webp"} loading="lazy" alt="" className="image-15" />
                                        </div>
                                        <div className="client-modal-lical-info-header-local-description">{name}</div>
                                        <div className="client-modal-lical-info-header-local-name description-text" style={{ whiteSpace: 'pre-line' }}>
                                            {description}
                                        </div>
                                    </div>
                                    <div className="client-modal-lical-basic-info-list">

                                        {workingHours && (
                                            <div className="client-modal-lical-basic-info-div">
                                                <div className="client-modal-lical-basic-info-image-div">
                                                    <img src={ClockIcon} loading="lazy" alt="" className="icon-size-20" />
                                                </div>
                                                <div className="client-modal-lical-basic-info-content-div">
                                                    <div className="description-text">Radno vreme</div>
                                                    <div className="client-modal-lical-basic-info-text" style={{ whiteSpace: 'pre-line' }}>
                                                        {workingHours}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {address && (
                                            <div className="client-modal-lical-basic-info-div" >
                                                <div className="client-modal-lical-basic-info-image-div">
                                                    <img src={LocationGreyIcon} loading="lazy" alt="" className="icon-size-20" />
                                                </div>
                                                <div className="client-modal-lical-basic-info-content-div">
                                                    <div className="description-text">Adresa
                                                        <span
                                                            onClick={() => setIsStreetMapViewOpen(true)}
                                                            style={{
                                                                cursor: "pointer",
                                                                marginLeft: 8,
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                verticalAlign: "top",
                                                            }}
                                                            className="description-text"
                                                        >
                                                            Vidi na mapi
                                                            <img src={NewTabIcon} loading="lazy" alt="" className="icon-size-12" style={{ marginLeft: 4 }} />
                                                        </span>
                                                    </div>
                                                    <div className="client-modal-lical-basic-info-text" >
                                                        {address}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {phoneNumber && (
                                            <div className="client-modal-lical-basic-info-div">
                                                <div className="client-modal-lical-basic-info-image-div">
                                                    <img src={TelephoneIcon} loading="lazy" alt="" className="icon-size-20" />
                                                </div>
                                                <div className="client-modal-lical-basic-info-content-div">
                                                    <div className="description-text">Telefon</div>
                                                    <div className="client-modal-lical-basic-info-text">
                                                        {phoneNumber}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {email && (
                                            <div className="client-modal-lical-basic-info-div">
                                                <div className="client-modal-lical-basic-info-image-div">
                                                    <img src={MailGreyIcon} loading="lazy" alt="" className="icon-size-20" />
                                                </div>
                                                <div className="client-modal-lical-basic-info-content-div">
                                                    <div className="description-text">Email</div>
                                                    <div className="client-modal-lical-basic-info-text">
                                                        {email}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {website && (
                                            <div className="client-modal-lical-basic-info-div">
                                                <div className="client-modal-lical-basic-info-image-div">
                                                    <img src={InternetIcon} loading="lazy" alt="" className="icon-size-20" />
                                                </div>
                                                <div className="client-modal-lical-basic-info-content-div">
                                                    <div className="description-text">Web stranica</div>
                                                    <div className="client-modal-lical-basic-info-text">
                                                        <a href={website} target="_blank" rel="noopener noreferrer" className="client-modal-lical-basic-info-link">
                                                            {website}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {wiFiName && wiFiPassword && (
                                            <div className="client-modal-lical-basic-info-div">
                                                <div className="client-modal-lical-basic-info-image-div">
                                                    <img src={WifiIcon} loading="lazy" alt="" className="icon-size-20" />
                                                </div>
                                                <div className="client-modal-lical-basic-info-content-div">
                                                    <div className="description-text">WiFi ime</div>
                                                    <div className="client-modal-lical-basic-info-text">
                                                        {wiFiName}
                                                    </div>
                                                </div>
                                                <div className="client-modal-lical-basic-info-content-div">
                                                    <div className="description-text">WiFi lozinka</div>
                                                    <div className="client-modal-lical-basic-info-text">
                                                        {wiFiPassword}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    </div>

                                    <div className="client-modal-lical-social-media-block">

                                        {socialLinks.map((link) => (
                                            link.url && (
                                                <div key={link.type} className="client-modal-lical-social-media-div" onClick={() => { window.document.location = link.url; }}>
                                                    <img src={renderSocialIcon(link.type)} loading="lazy" alt="" className="icon-size-20" />
                                                    <div className="description-text">{link.name}</div>
                                                </div>
                                            )
                                        ))}

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </motion.section>
            </section>
        </>
    );
};

export default LocalInfoView;